const BDSwordModule = require('./bdsword.js');

let Module;
if (typeof Module == 'undefined') {
    Module = null;
}

function InitBDSwordSync() {
    if (Module == null) {
        Module = BDSwordModule();
    }
}

function intArrayFromString(data, length = 0) {
    var len = 0;
    if (length <= 0) {
        len = data.length;
    } else {
        len = length;
    }
    if (len == 0) return null;

    var u8array = new Array(len);
    for (var i = 0; i < len; i++) {
        if (i > data.length) {
            u8array[i] = 0;
            continue;
        }
        var u = data.charCodeAt(i);
        u8array[i] = u;
    }
    return u8array;
}

function cUInt8Array(size) {
    if (Module == null) {
        InitBDSwordSync();
    }

    if (size <= 0) return null;

    var offset = Module._malloc(size);
    if (offset == null) return null;

    Module.HEAPU8.set(new Uint8Array(size), offset);
    return {
        "data": Module.HEAPU8.subarray(offset, offset + size),
        "offset": offset
    }
}

function cfreeArray(ptr) {
    if (Module == null) {
        InitBDSwordSync();
    }

    if (!ptr || typeof ptr.offset != 'number') {
        console.log("free error ", ptr);
        return;
    }
    Module._free(ptr.offset);
    return;
}

function EncryptData(data) {
    if (Module == null) {
        InitBDSwordSync();
    }

    var intArr = intArrayFromString(data);
    if (intArr == null) return null;

    var inData = Module.allocate(intArr, Module.ALLOC_NORMAL);
    if (inData == null) {
        console.log("EncryptData malloc failed");
        return null;
    }

    var outLen = cUInt8Array(4);
    if (outLen == null) return null;

    var result = Module.ccall('cmd_clientEncrypt', 'number', ['number', 'number', 'string', 'number'], [inData, intArr.length, null, outLen.offset]);
    var outLenNum = Module.getValue(outLen.offset, "i32");
    if (outLenNum <= 0) return null;

    var outStr = cUInt8Array(outLenNum);
    if (outStr == null || typeof (outStr) == "undefined") return null;

    var result = Module.ccall('cmd_clientEncrypt', 'number', ['number', 'number', 'number', 'number'], [inData, intArr.length, outStr.offset, outLen.offset]);

    var outLenNum = Module.getValue(outLen.offset, "i32");
    var encStr = Module.intArrayToString(outStr.data, 0, outLenNum);

    Module._free(inData);
    cfreeArray(outLen);
    cfreeArray(outStr);

    return {
        "result": result,
        "outLen": outLenNum,
        "encData": encStr
    }
}

function DecryptData(data) {
    if (Module == null) {
        InitBDSwordSync();
    }

    var intArr = intArrayFromString(data);
    if (intArr == null) return null;

    var inData = Module.allocate(intArr, Module.ALLOC_NORMAL);
    if (inData == null) {
        console.log("DecryptData malloc failed");
        return null;
    }

    var outLen = cUInt8Array(4);
    if (outLen == null) return null;

    var result = Module.ccall('cmd_clientDecrypt', 'number', ['number', 'number', 'string', 'number'], [inData, intArr.length, null, outLen.offset])

    var outLenNum = Module.getValue(outLen.offset, "i32")
    if (outLenNum <= 0) return null;

    var outStr = cUInt8Array(outLenNum);
    if (outStr == null || typeof (outStr) == "undefined") return null;

    var result = Module.ccall('cmd_clientDecrypt', 'number', ['number', 'number', 'number', 'number'], [inData, intArr.length, outStr.offset, outLen.offset])

    var outLenNum = Module.getValue(outLen.offset, "i32");
    var decStr = Module.UTF8ArrayToString(outStr.data, 0, outLenNum);

    Module._free(inData);
    cfreeArray(outLen);
    cfreeArray(outStr);

    return {
        "result": result,
        "outLen": outLenNum,
        "decData": decStr
    }
}

function waitForInitialized() {
    return new Promise(function (resove, reject) {
        Module.onRuntimeInitialized = () => {
            resove();
        }
    })
}

function RC4Encrypt(data, key = "") {
    if (Module == null) {
        InitBDSwordSync();
    }
    var intDataArr = intArrayFromString(data);
    if (intDataArr == null) return null;

    var inData = Module.allocate(intDataArr, Module.ALLOC_NORMAL);
    if (inData == null) {
        console.log("RC4Encrypt malloc failed");
        return null;
    }

    var keySeedPtr;
    if (key.length > 0) {
        keySeedPtr = cUInt8Array(32);
        if (keySeedPtr == null) return null;

        var keyArr = intArrayFromString(key);
        if (keyArr == null) return null;

        Module.HEAPU8.set(keyArr, keySeedPtr.offset);
    } else {
        keySeedPtr = GenKeySeed();
    }

    if (!keySeedPtr || typeof keySeedPtr.offset != 'number') {
        console.log(ptr);
        return null;
    }

    var outLen = cUInt8Array(4);
    if (outLen == null) return null;

    var result = Module.ccall('cmd_clientEncryptKSNaked', 'number', ['number', 'number', 'string', 'number, number, number'], [inData, intDataArr.length, null, outLen.offset, 3, keySeedPtr.offset]);
    var outLenNum = Module.getValue(outLen.offset, "i32");
    if (outLenNum <= 0) return null;

    var outStr = cUInt8Array(outLenNum);
    if (outStr == null || typeof (outStr) == "undefined") return null;

    var result = Module.ccall('cmd_clientEncryptKSNaked', 'number', ['number', 'number', 'number', 'number, number, number'], [inData, intDataArr.length, outStr.offset, outLen.offset, 3, keySeedPtr.offset]);

    var outLenNum = Module.getValue(outLen.offset, "i32");
    var encStr = Module.intArrayToString(outStr.data, 0, outLenNum);
    var keyStr = Module.intArrayToString(keySeedPtr.data, 0, 32);

    Module._free(inData);
    cfreeArray(keySeedPtr)
    cfreeArray(outLen);
    cfreeArray(outStr);

    return {
        "result": result,
        "key": keyStr,
        "outLen": outLenNum,
        "encData": encStr
    }
}

function GenKeySeed() {
    if (Module == null) {
        InitBDSwordSync();
    }

    var keySeedPtr = cUInt8Array(32);
    if (keySeedPtr == null) return null;
    Module.ccall('cmd_genKeySeed', 'number', ['number'], [keySeedPtr.offset]);
    return keySeedPtr;
}

function RC4Decrypt(data, key) {
    if (Module == null) {
        InitBDSwordSync();
    }

    var intDataArr = intArrayFromString(data);
    if (intDataArr == null) return null;

    var inDataPtr = Module.allocate(intDataArr, Module.ALLOC_NORMAL);
    if (inDataPtr == null) {
        console.log("RC4Decrypt malloc failed");
        return null;
    }

    var keySeedPtr = cUInt8Array(32);
    if (keySeedPtr == null) return null;

    var keyArr = intArrayFromString(key);
    if (keyArr == null) return null;

    Module.HEAPU8.set(keyArr, keySeedPtr.offset);

    var outLen = cUInt8Array(4);
    if (outLen == null) return null;

    var result = Module.ccall('cmd_clientDecryptKSNaked', 'number', ['number', 'number', 'string', 'number, number, number'], [inDataPtr, intDataArr.length, null, outLen.offset, 3, keySeedPtr.offset]);

    var outLenNum = Module.getValue(outLen.offset, "i32");
    if (outLenNum <= 0) return null;

    var outStr = cUInt8Array(outLenNum);
    if (outStr == null || typeof (outStr) == "undefined") return null;

    var result = Module.ccall('cmd_clientDecryptKSNaked', 'number', ['number', 'number', 'number', 'number, number, number'], [inDataPtr, intDataArr.length, outStr.offset, outLen.offset, 3, keySeedPtr.offset]);

    var outLenNum = Module.getValue(outLen.offset, "i32");
    var decStr = Module.UTF8ArrayToString(outStr.data, 0, outLenNum);

    Module._free(inDataPtr);
    cfreeArray(keySeedPtr)
    cfreeArray(outLen);
    cfreeArray(outStr);

    return {
        "result": result,
        "outLen": outLenNum,
        "decData": decStr
    }
}

// bdsword_async.js is compiled in emscripten to support async wasm loading
const loadBdswordModuleAsync = require('./bdsword_async.js')

// Functions 
async function initBdswordAsync() {
    const moduleInstance = await loadBdswordModuleAsync();

    function genKeySeed() {
        var keySeedPtr = cUInt8Array(32);
        if (keySeedPtr == null) return null;
        moduleInstance.ccall('cmd_genKeySeed', 'number', ['number'], [keySeedPtr.offset]);
        return keySeedPtr;
    }

    function cUInt8Array(size) {
        if (size <= 0) return null;

        var offset = moduleInstance._malloc(size);
        if (offset == null) return null;

        moduleInstance.HEAPU8.set(new Uint8Array(size), offset);
        return {
            "data": moduleInstance.HEAPU8.subarray(offset, offset + size),
            "offset": offset
        }
    }

    function intArrayFromString(data, length = 0) {
        var len = 0;
        if (length <= 0) {
            len = data.length;
        } else {
            len = length;
        }
        if (len == 0) return null;

        var u8array = new Array(len);
        for (var i = 0; i < len; i++) {
            if (i > data.length) {
                u8array[i] = 0;
                continue;
            }
            var u = data.charCodeAt(i);
            u8array[i] = u;
        }
        return u8array;
    }

    function cfreeArray(ptr) {
        if (!ptr || typeof ptr.offset != 'number') {
            console.log("free error ", ptr);
            return;
        }
        moduleInstance._free(ptr.offset);
        return;
    }

    // Returns the API methods contained in a JS object
    return {
        encryptData: async function (data) {
            var intArr = intArrayFromString(data);
            if (intArr == null) return null;

            var inData = moduleInstance.allocate(intArr, moduleInstance.ALLOC_NORMAL);
            if (inData == null) {
                console.log("EncryptData malloc failed");
                return null;
            }

            var outLen = cUInt8Array(4);
            if (outLen == null) return null;

            var result = moduleInstance.ccall('cmd_clientEncrypt', 'number', ['number', 'number', 'string', 'number'], [inData, intArr.length, null, outLen.offset]);
            var outLenNum = moduleInstance.getValue(outLen.offset, "i32");
            if (outLenNum <= 0) return null;

            var outStr = cUInt8Array(outLenNum);
            if (outStr == null || typeof (outStr) == "undefined") return null;

            var result = moduleInstance.ccall('cmd_clientEncrypt', 'number', ['number', 'number', 'number', 'number'], [inData, intArr.length, outStr.offset, outLen.offset]);

            var outLenNum = moduleInstance.getValue(outLen.offset, "i32");
            var encStr = moduleInstance.intArrayToString(outStr.data, 0, outLenNum);

            moduleInstance._free(inData);
            cfreeArray(outLen);
            cfreeArray(outStr);

            return {
                "result": result,
                "outLen": outLenNum,
                "encData": encStr
            }

        },
        decryptData: async function (data) {
            var intArr = intArrayFromString(data);
            if (intArr == null) return null;

            var inData = moduleInstance.allocate(intArr, moduleInstance.ALLOC_NORMAL);
            if (inData == null) {
                console.log("DecryptData malloc failed");
                return null;
            }

            var outLen = cUInt8Array(4);
            if (outLen == null) return null;

            var result = moduleInstance.ccall('cmd_clientDecrypt', 'number', ['number', 'number', 'string', 'number'], [inData, intArr.length, null, outLen.offset])

            var outLenNum = moduleInstance.getValue(outLen.offset, "i32")
            if (outLenNum <= 0) return null;

            var outStr = cUInt8Array(outLenNum);
            if (outStr == null || typeof (outStr) == "undefined") return null;

            var result = moduleInstance.ccall('cmd_clientDecrypt', 'number', ['number', 'number', 'number', 'number'], [inData, intArr.length, outStr.offset, outLen.offset])

            var outLenNum = moduleInstance.getValue(outLen.offset, "i32");
            var decStr = moduleInstance.UTF8ArrayToString(outStr.data, 0, outLenNum);

            moduleInstance._free(inData);
            cfreeArray(outLen);
            cfreeArray(outStr);

            return {
                "result": result,
                "outLen": outLenNum,
                "decData": decStr
            }
        },
        rc4Encrypt: async function (data, key = "") {
            var intDataArr = intArrayFromString(data);
            if (intDataArr == null) return null;

            var inData = moduleInstance.allocate(intDataArr, moduleInstance.ALLOC_NORMAL);
            if (inData == null) {
                console.log("RC4Encrypt malloc failed");
                return null;
            }

            var keySeedPtr;
            if (key.length > 0) {
                keySeedPtr = cUInt8Array(32);
                if (keySeedPtr == null) return null;

                var keyArr = intArrayFromString(key);
                if (keyArr == null) return null;

                moduleInstance.HEAPU8.set(keyArr, keySeedPtr.offset);
            } else {
                keySeedPtr = genKeySeed();
                console.log(keySeedPtr)
            }

            if (!keySeedPtr || typeof keySeedPtr.offset != 'number') {
                console.log(ptr);
                return null;
            }

            var outLen = cUInt8Array(4);
            if (outLen == null) return null;

            var result = moduleInstance.ccall('cmd_clientEncryptKSNaked', 'number', ['number', 'number', 'string', 'number, number, number'], [inData, intDataArr.length, null, outLen.offset, 3, keySeedPtr.offset]);
            var outLenNum = moduleInstance.getValue(outLen.offset, "i32");
            if (outLenNum <= 0) return null;

            var outStr = cUInt8Array(outLenNum);
            if (outStr == null || typeof (outStr) == "undefined") return null;

            var result = moduleInstance.ccall('cmd_clientEncryptKSNaked', 'number', ['number', 'number', 'number', 'number, number, number'], [inData, intDataArr.length, outStr.offset, outLen.offset, 3, keySeedPtr.offset]);

            var outLenNum = moduleInstance.getValue(outLen.offset, "i32");
            var encStr = moduleInstance.intArrayToString(outStr.data, 0, outLenNum);
            var keyStr = moduleInstance.intArrayToString(keySeedPtr.data, 0, 32);

            moduleInstance._free(inData);
            cfreeArray(keySeedPtr)
            cfreeArray(outLen);
            cfreeArray(outStr);

            return {
                "result": result,
                "key": keyStr,
                "outLen": outLenNum,
                "encData": encStr
            }
        },
        rc4Decrypt: async function (data, key) {
            var intDataArr = intArrayFromString(data);
            if (intDataArr == null) return null;

            var inDataPtr = moduleInstance.allocate(intDataArr, moduleInstance.ALLOC_NORMAL);
            if (inDataPtr == null) {
                console.log("RC4Decrypt malloc failed");
                return null;
            }

            var keySeedPtr = cUInt8Array(32);
            if (keySeedPtr == null) return null;

            var keyArr = intArrayFromString(key);
            if (keyArr == null) return null;

            moduleInstance.HEAPU8.set(keyArr, keySeedPtr.offset);

            var outLen = cUInt8Array(4);
            if (outLen == null) return null;

            var result = moduleInstance.ccall('cmd_clientDecryptKSNaked', 'number', ['number', 'number', 'string', 'number, number, number'], [inDataPtr, intDataArr.length, null, outLen.offset, 3, keySeedPtr.offset]);

            var outLenNum = moduleInstance.getValue(outLen.offset, "i32");
            if (outLenNum <= 0) return null;

            var outStr = cUInt8Array(outLenNum);
            if (outStr == null || typeof (outStr) == "undefined") return null;

            var result = moduleInstance.ccall('cmd_clientDecryptKSNaked', 'number', ['number', 'number', 'number', 'number, number, number'], [inDataPtr, intDataArr.length, outStr.offset, outLen.offset, 3, keySeedPtr.offset]);

            var outLenNum = moduleInstance.getValue(outLen.offset, "i32");
            var decStr = moduleInstance.UTF8ArrayToString(outStr.data, 0, outLenNum);

            moduleInstance._free(inDataPtr);
            cfreeArray(keySeedPtr)
            cfreeArray(outLen);
            cfreeArray(outStr);

            return {
                "result": result,
                "outLen": outLenNum,
                "decData": decStr
            }
        }
    }
}

module.exports = {
    InitBDSwordSync,
    EncryptData,
    DecryptData,
    RC4Encrypt,
    RC4Decrypt,
    Module,
    initBdswordAsync
}